<template>
  <hel-module title="企业全域数字孪生体" :class="scope.clsPrefix">
    <div class="twin-container">
      <div class="twin-desc">
        围绕制造、供应、供应、销售、物流与财务五大业务域，联动中心端实时映射企业运行态势与态势与关键风险。
      </div>
      <div class="twin-content">
        <div class="domain-card"
             v-for="(domain, index) in domains"
             :key="index +  'domain'"
             :class="[`domain-${domain.key}`, `status-${domain.status}`]"
             @click="handleDomainClick(domain)">
          <div class="domain-header">
            <span class="dot normal-dot"></span>
            <span class="domain-name">{{ domain.name }}</span>
          </div>
          <div class="domain-content">
            <div class="domain-unit">{{ domain.unit }}</div>
            <div class="domain-value">{{ domain.value }}</div>
          </div>
          <div class="domain-sub">{{ domain.sub }}</div>
        </div>

        <div class="status-bar">
          <span class="status-item normal"><span class="dot normal-dot"></span>正常</span>
          <span class="status-item warning"><span class="dot warning-dot"></span>预警</span>
          <span class="status-item danger"><span class="dot danger-dot"></span>告警</span>
          <span class="status-item offline"><span class="dot offline-dot"></span>离线</span>
        </div>

        <!-- <button class="twin-btn">数字驾驶舱</button> -->
        <img class="twin-btn" src="@/assets/imgs/jiashicang.png" width="127px" alt="">
      </div>

      <div v-if="activeDomain" class="detail-panel">
        <div class="panel-header">
          <span class="panel-title"><span class="dot normal-dot"></span>{{ activeDomain.name }}</span>
          <span class="panel-close" @click="activeDomain = null">×</span>
        </div>
        <div class="panel-content-container">
          <div class="panel-sub-desc">{{ activeDomain.subDesc }}</div>
          <div class="panel-desc">{{ activeDomain.desc }}</div>
          <div class="panel-content">
            <div class="content-grid">
              <div class="grid-item" v-for="(item, idx) in activeDomain.details" :key="idx">
                <div class="item-label">{{ item.label }}</div>
                <div class="item-value">{{ item.value }}</div>
              </div>
            </div>
            <div class="content-section" style="margin-bottom: 24px;">
              <div class="section-title">构成信息</div>
              <div class="section-item" v-for="(item, idx) in activeDomain.composition" :key="idx">
                <div class="comp-label">{{ item.label }}</div>
                <div class="comp-value">{{ item.value }}</div>
              </div>
            </div>
            <div class="content-section">
              <div class="section-title">关键看点</div>
              <div class="point-container">
                <div class="point-section-item" v-for="(item, idx) in activeDomain.point" :key="idx">
                <div class="point-label"><span class="point-dot"></span>{{ item.label }}</div>
                <!-- <div class="point-value">{{ item.value }}</div> -->
              </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
export default {
  name: 'DigitalTwin',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-digital-twin'
      },
      backgroundImage: '',
      activeDomain: null,
      domains: [
        {
          key: 'manufacture',
          name: '制造域',
          value: '98.6%',
          unit: '设备在线率',
          sub: '45万吨/年',
          status: 'normal',
          subDesc: '三基地产能与订单联动',
          desc: '三大基地围绕动力、储能与磷资源协同排产，通过跨基地调度承接高压实动力订单增量。',
          details: [
            { label: '设备在线率', value: '98.6%' },
            { label: '跨基地协同订单', value: '7 单' },
            { label: '总产能', value: '45 万台/年' },
            { label: '本周扩产爬坡', value: '2 条产线' }
          ],
          composition: [
            { label: '基地构成', value: '宜宾动力、宜昌磷系、宜春储能三基地' },
            { label: '产线构成', value: '高压实动力线、储能线、前驱体协同线' },
            { label: '协同对象', value: '排产、设备、工艺、质量四类制造单元' }
          ],
          point: [
            { label: '宜宾基地承接高压实动力订单增量，排产利用率维持在 92% 以上', value: '98.6%' },
            { label: '宜昌基地优先补充前驱体与磷资源协同，保障双产品线稳定出货。', value: '98.6%' },
            { label: '宜春基地聚焦储能线爬坡与新品验证，控制放量节奏避免低价侵蚀毛利。', value: '98.6%' }
          ]
        },
        {
          key: 'sales',
          name: '销售域',
          value: '95.2%',
          unit: '目标达成',
          sub: '季度营收 31.8 亿元',
          status: 'normal',
          subDesc: '客户结构与订单质量联接',
          desc: '围绕核心客户的订单结构、价格带与交付承诺进行动态评估。',
          details: [
            { label: '季度营收', value: '31.8亿' },
            { label: '目标达成', value: '95.2%' },
            { label: '核心客户营收占比', value: '63%' },
            { label: '低价销售单占比', value: '持续抬升' }
          ],
          composition: [
            { label: '客户构成', value: '宁德时代、比亚迪与区域储能客户为主' },
            { label: '订单构成', value: '动力单、高压实单、储能单、海外试点单' },
            { label: '价格带构成', value: '高毛利动力、高增速储能、培育型海外三层' }
          ],
          point: [
            { label: '核心客户仍是最关键增量来源，需要同步盯防客户集中度与价格下探。', value: '95.2%' },
            { label: '低价储能订单是毛利预警的首要触发因素，需要经营条线联动修正。', value: '95.2%' },
            { label: '海外客户群占比仍低，后续需引导高毛利产品逐步拓展国际客户池。', value: '95.2%' }
          ]
        },
        {
          key: 'logistics',
          name: '物流域',
          value: '43',
          unit: '主线路由',
          sub: '接单响应4小时',
          status: 'normal',
          subDesc: '主线路时效与交付承诺协同',
          desc: '围绕 43 条主干物流线路，重点盯防华东与西南干线时效波动。',
          details: [
            { label: '全球物流主线路', value: '43 条' },
            { label: '时效预警', value: '2 条' },
            { label: '关键客户插单响应', value: '4 小时' },
            { label: '成品安全库存', value: '5 天' }
          ],
          composition: [
            { label: '网络构成', value: '公路干线、铁路联运、港口转运三类通道' },
            { label: '区域构成', value: '华东、西南、华中三大核心交付带' },
            { label: '履约构成', value: '主线路时效、插单响应、库存前置一体协同' }
          ],
          point: [
            { label: '华东与西南干线波动需要动态调度，确保重点客户出货节点稳定。', value: '43%' },
            { label: '当前物流协同与排产联动已缩短关键订单插单响应时间至 4 小时', value: '43%' },
            { label: '需把成品安全库存与物流路由决策联动，防止区域波动放大交付风险', value: '43%' }
          ]
        },
        {
          key: 'finance',
          name: '财务域',
          value: '+2.4',
          unit: '经营现金流',
          sub: '经营现金流 17.6%',
          status: 'normal',
          subDesc: '现金流、毛利与扩产投入管控',
          desc: '聚焦经营性现金流转正、综合毛利率不低于 18% 与扩产投资节奏三条主线。',
          details: [
            { label: '经营现金流', value: '+2.4 亿元' },
            { label: '综合毛利率', value: '17.6%' },
            { label: '毛利偏差', value: '-0.4pct' },
            { label: '扩产项目达成', value: '66%' }
          ],
          composition: [
            { label: '指标构成', value: '现金流、毛利率、资本开支、库存占款四项联接' },
            { label: '资金构成', value: '经营回款、采购支出、扩产投入、融资安排' },
            { label: '管控构成', value: '上市约束线、季度预算线、项目节点线三层机制' }
          ],
          point: [
            { label: '综合毛利率跌破上市安全线，财务域需联动销售与制造一起修复低价订单结构。', value: '+2.4%' },
            { label: '经营性现金流已转正，但扩产节奏与库存占款仍需受控推进。', value: '+2.4%' },
            { label: '后续应将毛利修复动作与资本开支节点联动，保证 2027 战略项目按节奏落地。', value: '+2.4%' }
          ]
        },
        {
          key: 'supply',
          name: '供应域',
          value: '27',
          unit: 'A级供应商',
          sub: '保供预案已启动',
          status: 'normal',
          subDesc: '核心资源保供与替代方案',
          desc: '围绕锂盐、磷资源与 A 级供应商构建保供网络，对高风险原料保持日级监控与替代预案。',
          details: [
            { label: 'A 级供应商', value: '27 家' },
            { label: '锂盐安全库存', value: '8 天' },
            { label: '前驱体自供率', value: '90%' },
            { label: '应急保供策略', value: '已启动' }
          ],
          composition: [
            { label: '资源构成', value: '锂盐、磷资源、前驱体、包材四类核心原料' },
            { label: '供应层级', value: 'A 级主供、B 级备供、应急替代三级网络' },
            { label: '保障机制', value: '锁价、替代切换、安全库存三道保供策略' }
          ],
          point: [
            { label: '锂盐供应集中度偏高，已触发替代供应商与锁价谈判联动机制', value: '27%' },
            { label: '宜昌基地依托磷资源协同优势，维持双产品线的原料韧性。', value: '27%' },
            { label: '核心原料安全库存策略已提升至 15 天目标，优先保障上市约束订单。', value: '27%' }
          ]
        }
      ]
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      if (this.data && this.data.backgroundImage) {
        this.backgroundImage = this.data.backgroundImage
      }
    })
  },
  methods: {
    handleDomainClick(domain) {
      this.activeDomain = domain
    }
  }
}
</script>

<style lang="scss">
$class-prefix: "rvc-cosmoplat-workspace-digital-twin";
.#{$class-prefix} {
  .twin-container {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .twin-content {
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    // z-index: 10;
    flex: 1;
    padding: 24px;
    box-sizing: border-box;
    min-height: 500px;
    background-image: url("@/assets/imgs/twins_bg.jpg");
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
  }

  .twin-desc {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    margin-bottom: 12px;
  }

  .domain-card {
    position: absolute;
    width: 186px;
    height: 96px;
    background-image: radial-gradient(100% 60%, #DDE4FF 0%, #ffffff00 99%);
    box-shadow: 0 20px 9px 0 #005ddd33;
    border-radius: 8px;
    backdrop-filter: blur(6px);
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 30px rgba(74, 95, 243, 0.15);
    }

    &.domain-manufacture {
      top: 9.2%;
      left: 9.2%;
    }

    &.domain-sales {
      top: 4.8%;
      right: 28.5%;
    }

    &.domain-logistics {
      top: 16%;
      right: 8.5%;
    }

    &.domain-finance {
      top: 42.4%;
      right: 8.5%;
    }

    &.domain-supply {
      bottom: 23.8%;
      left: 9.2%;
    }
  }

  .domain-header {
    display: flex;
    align-items: center;
    height: 28px;
    background-image: url("@/assets/imgs/title.png");
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: left center; /* 左对齐，根据UI调整center/left */
    // background-size: cover;
    gap: 5px;
    margin-bottom: 12px;
    padding: 0 8px;
  }

  .domain-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #4a5ff3;

    .status-warning & {
      background: #faad14;
    }

    .status-danger & {
      background: #F44F4F;
    }

    .status-offline & {
      background: #999999;
    }
  }

  .domain-name {
    font-family: PingFangSC-Medium;
    font-weight: 600;
    font-size: 12px;
    color: #333333;
    // position: relative;
    // top: -1px;
  }

  .domain-value {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 14px;
    color: #4A5FF3;
  }
  .domain-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 6px;
  }

  .domain-unit {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 14px;
    color: #4A5FF3;
  }

  .domain-sub {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    padding: 0 20px;
  }

  .status-bar {
    position: absolute;
    bottom: 9px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 16px;
    width: 220px;
    height: 36px;
    background: #FFFFFF;
    box-shadow: 0 20px 9px 0 #005ddd33;
    border-radius: 8px;
    backdrop-filter: blur(6px);
    padding: 10px 16px;
  }

  .status-item {
    flex: 1;
    font-size: 12px;
    // padding: 4px 12px;
    // border-radius: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.normal {
      // background: #f6ffed;
      color: #4A5FF3;
    }

    &.warning {
      // background: #fffbe6;
      color: #F4B13D;
    }

    &.danger {
      // background: #fff1f0;
      color: #F44F4F;
    }

    &.offline {
      // background: #f5f5f5;
      color: #999999;
    }
  }

  .twin-btn {
    position: absolute;
    bottom: 7px;
    right: 0px;
    // background: linear-gradient(135deg, #4a5ff3 0%, #6b7dff 100%);
    // color: #ffffff;
    border: none;
    // padding: 10px 24px;
    // border-radius: 8px;
    // font-size: 14px;
    // font-weight: 500;
    cursor: pointer;
    // transition: all 0.3s ease;

    // &:hover {
    //   transform: translateY(-2px);
    //   box-shadow: 0 4px 15px rgba(74, 95, 243, 0.4);
    // }
  }

  .detail-panel {
    position: absolute;
    top: calc(50% + 12px);
    right: 35px;
    width: 380px;
    height: calc(100% - 72px);
    transform: translateY(-50%);
    background: #ffffff99;
    box-shadow: 0 20px 16px 0 #005ddd33, inset 0 0 8px 0 #ffffff80;
    border-radius: 12px;
    backdrop-filter: blur(6px);
    z-index: 20;
    padding: 16px;
    padding-right: 0;
    box-sizing: border-box;
    // animation: slideIn 0.3s ease;
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .panel-content-container {
    height: calc(100% - 48px);
    overflow-y: auto;
    padding-right: 16px;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: #f0f0f0;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 3px;
      &:hover {
        background: #cacaca;
        cursor: pointer;
      }
    }
  }

  .panel-title {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .panel-close {
    font-weight: 300;
    font-size: 24px;
    color: #333;
    cursor: pointer;
    line-height: 1;
    position: relative;
    top: -6px;
    right: 10px;

    &:hover {
      color: #333;
    }
  }
  .panel-sub-desc {
    font-size: 14px;
    line-height: 1;
    color: #333;
    font-weight: 600;
    line-height: 1.6;
    margin-bottom: 4px;
  }

  .panel-desc {
    font-size: 12px;
    color: #999;
    line-height: 1.6;
    margin-bottom: 20px;
  }

  .content-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 24px;
  }

  .grid-item {
    height: 72px;
    background: #f8f9ff;
    border-radius: 8px;
    padding: 12px;
    text-align: center;
    background: #FEFEFF;
    border-radius: 4px;
    backdrop-filter: blur(6px);
  }

  .item-label {
    font-size: 12px;
    color: #333;
    margin-bottom: 7px;
  }

  .item-value {
    font-size: 16px;
    font-weight: 700;
    color: #4a5ff3;
  }

  .content-section {
    // background: #f8f9ff;
    // border-radius: 8px;
    // padding: 16px;
  }

  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 12px;
  }

  .section-item {
    margin-bottom: 4px;
    height: 60px;
    background: #FFFFFF;
    border: 1px solid #EDF1FB;
    border-radius: 4px;
    padding: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .comp-label {
    font-size: 12px;
    color: #999999;
    margin-bottom: 6px;
  }

  .comp-value {
    font-weight: 600;
    font-size: 12px;
    color: #4A5FF3;
  }
}
.dot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      &.normal-dot {
        border: 2px solid #4A5FF3;
      }

      &.warning-dot {
        border: 2px solid #F4B13D;
      }

      &.danger-dot {
        border: 2px solid #f5222d;
      }

      &.offline-dot {
        border: 2px solid #999999;
      }
    }
    .point-container {
      display: flex;
      flex-direction: column;
      padding: 16px;
      gap: 16px;
      border: 1px solid #EDF1FB;
      background: white;
      border-radius: 8px;
      .point-section-item {
        .point-label {
          font-weight: 600;
          font-size: 12px;
          color: #4A5FF3;
          display: flex;
          align-items: center;
          gap: 16px;
          .point-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #4A5FF3;
          }
        }
        .point-value {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          padding-left: 23px;
        }
      }
    }
</style>
